import { Button } from "@fluentui/react-components";
import { IAppealButtonRowProps } from "../../model/interface";
import { AppealPage } from "../../model/enum";
import { useTranslation } from "react-i18next";
import "./AppealButtonRow.scss"
import { useEffect, useRef } from "react";

export default function AppealButtonRow(props: IAppealButtonRowProps) {
    const { t } = useTranslation();
    const backButtonRef = useRef<HTMLButtonElement>(null);
    const continueButtonRef = useRef<HTMLButtonElement>(null);

    // Focus on appropriate buttons
    useEffect(() => {
        if (props.hipSolved && props.currentPage === AppealPage.Hip && !isGoBackDisabled()) {
            backButtonRef.current?.focus();
        }

        if (props.currentPage === AppealPage.Landing) {
            continueButtonRef.current?.focus();
        }
    }, [props.hipSolved, props.currentPage]);

    const isGoBackDisabled = () => { 
        return props.isRequestProcessing;
    }

    const isContinueDisabled = () => { 
        return (!props.hipSolved && props.currentPage === AppealPage.Hip) || (!props.formValid && props.currentPage === AppealPage.Form);
    }

    const isSubmitDisabled = () => { 
        return !props.preSubmissionValid || props.isRequestProcessing;
    }

    return (
        <div className="appeal-button-row">
            {(props.currentPage > AppealPage.Landing && props.currentPage < AppealPage.Submission) &&
                <Button ref={backButtonRef} id="appeal-btn-row-go-back" data-testid="appeal-btn-row-go-back" onClick={props.handleBack} disabled={isGoBackDisabled()}>
                    {t('Common.go-back')}
                </Button>
            }
            {props.currentPage < AppealPage.PreSubmission &&
                <Button ref={continueButtonRef} id="appeal-btn-row-continue" data-testid="appeal-btn-row-continue" onClick={props.handleContinue} appearance="primary" disabled={isContinueDisabled()}>
                    {t('Common.continue')}
                </Button>
            }
            {props.currentPage === AppealPage.PreSubmission &&
                <Button id="appeal-btn-row-submit" data-testid="appeal-btn-row-submit" onClick={props.handleSubmit} appearance="primary" disabled={isSubmitDisabled()}>
                    {t('Appeal.Common.submit-appeal')}
                </Button>
            }
        </div>
    )

}